import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import SimpleRow from '../../../../components/simpleRow/SimpleRow';
import { isPageShouldBreak } from '../../../../utils/shared/printUtils';
import { getSortedResultsByDate } from '../../../../utils/shared/sortUtils';
import MeasureWithStudentPrintInfo from './MeasureWithStudentPrintInfo';
import MeasureRow from './MeasureRow';
import { generateReactKey } from '../../../../utils/shared/commonUtils';
import { createDataTourStep } from '../../../../utils/shared/demoModeUtils';

const columns = ['Date', 'Form', 'Score'];

const MeasureDataGrid = ({
    interps,
    openProbeDetails,
    statuses,
    location,
    pageBreakingRowIndex,
    measure,
    grade,
    student,
    getMeasureTitle,
    CommonCellBuilder,
    isGoalAvailable,
    getSpecificGoal,
    summerPeriodLabel,
}) => {
    let prevPageBreakingRowIndex = pageBreakingRowIndex;
    return (
        <div
            className="measure-data-grid"
            data-tour-step={createDataTourStep(`${measure}-measure-data-grid`)}
        >
            <SimpleRow
                rowClassNames="grid-row border-top"
                cellClassNames="grid-cell grid-header-cell"
                headerCellsDataTestId="ss-progress-row-header-cells"
                columns={columns}
            />
            {getSortedResultsByDate(statuses).map((data, rowIndex) => {
                const isPageBreak = isPageShouldBreak(prevPageBreakingRowIndex, rowIndex);
                if (isPageBreak) {
                    prevPageBreakingRowIndex = rowIndex;
                }
                return (
                    <Fragment key={generateReactKey(rowIndex)}>
                        {isPageBreak && (
                            <>
                                <MeasureWithStudentPrintInfo
                                    student={student}
                                    measure={measure}
                                    grade={grade}
                                    titleClassName="title-page-break"
                                    getMeasureTitle={getMeasureTitle}
                                    wrapperClassName="wrapper-page-brake"
                                />
                                <SimpleRow
                                    rowClassNames="grid-row border-top print-mode"
                                    cellClassNames="grid-cell grid-header-cell"
                                    columns={columns}
                                />
                            </>
                        )}
                        <MeasureRow
                            className="grid-row"
                            data={data}
                            studentId={student.externalId}
                            location={location}
                            openProbeDetails={openProbeDetails}
                            interps={interps}
                            CommonCellBuilder={CommonCellBuilder}
                            isGoalAvailable={isGoalAvailable}
                            rowCellsDataTestId="ss-progress-data-row-cells"
                            getSpecificGoal={getSpecificGoal}
                            summerPeriodLabel={summerPeriodLabel}
                        />
                    </Fragment>
                );
            })}
        </div>
    );
};

MeasureDataGrid.defaultProps = {
    statuses: [],
    student: {},
    location: {},
    pageBreakingRowIndex: 0,
    grade: '',
    measure: '',
    getMeasureTitle: () => {},
    CommonCellBuilder: () => <></>,
    isGoalAvailable: () => {},
    getSpecificGoal: () => '',
};

MeasureDataGrid.propTypes = {
    interps: PropTypes.array.isRequired,
    openProbeDetails: PropTypes.func.isRequired,
    statuses: PropTypes.arrayOf(PropTypes.object),
    student: PropTypes.object,
    location: PropTypes.object,
    pageBreakingRowIndex: PropTypes.number,
    measure: PropTypes.string,
    grade: PropTypes.string,
    getMeasureTitle: PropTypes.func,
    CommonCellBuilder: PropTypes.func,
    isGoalAvailable: PropTypes.func,
    getSpecificGoal: PropTypes.func,
    summerPeriodLabel: PropTypes.string.isRequired,
};

export default MeasureDataGrid;
